import React from 'react'
import { motion } from 'framer-motion'
import etherfrens1 from '../assets/collection-preview.png' 

const About = () => {
  return (
    <>
    <div className='w-full'>
        <div className='max-w-[1240px] mx-auto'>
            <div className='p-10 sm:p-20 grid grid-cols-1 md:grid-cols-2 gap-x-8 content-start '>
                <motion.div
                    initial={{ x: -100, opacity: 0 }}
                    transition={{ delay: 0.25, duration: 0.5 }}
                    whileInView={{ opacity: 1, x: 0}}
                    viewport={{ once: true }}
                >
                   
                    <h1 className='text-3xl md:text-5xl font-bold py-5'>What is EtherFrens?</h1>
                    <p className='text-xl md:text-2xl py-5'>
                        EtherFrens is a limited profile picture-based NFT art collection built upon the Etherum Network. The project focuses on creating art for the community. Each Fren is released one by one as they are created and raffled on our twitter. 
                    </p>
                    {/* or applying to our Frensly (Frens Only) Application */}
                    <div className='content-center'> 
                        <p className='pt-8 font-semibold text-xl md:text-2xl'> Cant wait? Buy one now from opensea.</p>
                        <p className='pt-8'>
                            <a href={global.config.links.opensea} class="hover:text-white visited:text-white no-underline inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-lg text-white bg-blue-700 rounded-md hover:bg-blue-400 sm:w-auto sm:mb-0" data-primary="green-400" data-rounded="rounded-2xl" data-primary-reset="{}">
                            Buy on Opensea
                            <svg class="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                            </a>
                            {/* <a href="about" class="hover:text-white visited:text-white no-underline inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-lg text-white bg-green-500 rounded-md hover:bg-green-400 sm:w-auto sm:mb-0" data-primary="green-400" data-rounded="rounded-2xl" data-primary-reset="{}">
                            Apply Now
                            <svg class="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                            </a> */}
                        </p>
                    </div> 
                </motion.div>
                <motion.div
                        initial={{ x: 300, opacity: 0 }}
                        transition={{ delay: 0.25, duration: 0.5 }}
                        whileInView={{ opacity: 1, x: 0}}
                        viewport={{ once: true }}
                >
                    <img className='' src={etherfrens1} alt="" />
                </motion.div>
            </div>    
        </div>
    </div>
    </>
  )
}

export default About
